module.exports = __webpack_public_path__ + "static/media/css6.d0101c51.png";